import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { UnitAutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel';
import { UnitTypeResponse } from 'generated/CoreApi_v1';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UnitAutoCompleteHierarchical } from 'views/foundation/unit/components/UnitAutoCompleteHierarchical';
import { IAdvFilterPickerProps, IAdvFilterResult } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const UnitPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onError, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<UnitAutoCompleteHierarchicalModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);

    const unitType = filter.pickerParams as UnitTypeResponse | undefined;
    const multiSelect = filter.canRepeat ?? false;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label} ${item.includeDescendants ? "[+]" : ""}`,
                value: item.includeDescendants ? item.allUsersGroup.id : item.usersGroup.id,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: item.includeDescendants,
                unitTypeId: unitType?.unitTypeId
            })) as IAdvFilterResult[];
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <UnitAutoCompleteHierarchical
                    autoFocus
                    selectedMode='free'
                    showDescendantOption
                    multiSelect={multiSelect}
                    placeholder={filter.placeholder ?? t(`AdvFilter.Picker.Unit.Placeholder${multiSelect ? "_multi" : ""}`)}
                    selectedItems={selected}
                    applyEnter={{ onApply: handleApply, behavior: "SelectionOptionsEmpty" }}
                    onChange={(items) => setSelected(items)}
                    onError={onError}
                    onCancel={onCancel}
                    unitTypeId={unitType?.unitTypeId}
                    unitTypeName={unitType?.name}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
